import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CoreLogService } from "../../../core/services/log.service";
import * as Models from '../../models';
import { ISOTService } from '../../services';

export interface ProductTagFilterDialogConfig {
  productTags: Models.SOTProductTagViewModel[],
  selectedProductTags: number[];
  sot_service: ISOTService;
}

@Component({
  selector: "productTagFilterDialog",
  templateUrl: "./productTagFilterDialog.component.html",
  styleUrls: ["./productTagFilterDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ProductTagFilterDialogComponent implements OnInit {
  public productTags: Models.SOTProductTagViewModel[];
  public selectedProductTags: number[] = [];
  private _sotService: ISOTService;

  public constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<ProductTagFilterDialogComponent, number[]>,
    private _coreLogService: CoreLogService,
    @Inject(MAT_DIALOG_DATA) public productTagsConfig: ProductTagFilterDialogConfig
  ) {
    const me = this;
    me._sotService = productTagsConfig.sot_service;
    me.productTags = productTagsConfig.productTags;
    if (me.productTagsConfig.selectedProductTags.length > 0) {
      me.selectedProductTags = me.productTagsConfig.selectedProductTags;
    }
  }

  ngOnInit() {
    const me = this;
    me.PushChanges();
  }
  public get isModeOne(): boolean {
    return this.productTagsConfig.sot_service.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this.productTagsConfig.sot_service.Accessabilty.useModeTwo;
  }
  public selectTag(tagId: number) {
    const me = this;
    const index = me.selectedProductTags.indexOf(tagId)
    if (index == -1) {
      me.selectedProductTags.push(tagId)
    } else {
      me.selectedProductTags.splice(index, 1)
    }
    me.PushChanges();
  }

  public isHighlighted(tagId: number) {
    const me = this;
    return me.selectedProductTags.indexOf(tagId) !== -1;
  }

  public resetBtnDisabled(): boolean {
    const me = this;
    return me.selectedProductTags.length == 0;
  }

  public setSelectedTagFilter(): void {
    const me = this;
    me.dialogRef.close(me.selectedProductTags);
  }

  public resetSelectedTagFilter(): void {
    const me = this;
    me.selectedProductTags = [];
    me.dialogRef.close(me.selectedProductTags);
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("ProductTagFilterDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }
}